import React from 'react';
import projects from './Projects.json';

export default function Projects() {
  return (
    <main className="archive-page page-width">
      <span className="eyebrow">THE ANCIENT ARCHIVE / PRE–CLAUDE CODE ERA</span>
      <h1>Ancient projects<span className="pink">.</span></h1>
      <div className="archive-notice"><span aria-hidden="true">⌛</span><div><strong>These projects predate the Claude Code era.</strong><p>A time capsule of older work, preserved for posterity (and mild embarrassment). Descriptions and links are historical; demos may no longer work. For my current experience, <a href="/resume">read my latest resume</a>.</p></div></div>
      <div className="project-grid">{projects.map((project, index) => (
        <article className="archive-card" key={`${project.project_name}-${index}`}>
          <div className="card-index">EXHIBIT {String(index + 1).padStart(2, '0')} <span>ARCHIVED</span></div>
          {project.preview_images[0] && <img className="archive-image" src={project.preview_images[0]} alt={`${project.project_name} historical screenshot`} loading="lazy" />}
          <div className="archive-card-content"><p className="project-type">{project.type}</p><h2>{project.project_name}</h2><p>{project.desc}</p>{project.archive_note && <p className="project-archive-note">{project.archive_note}</p>}<ul className="tech-list" aria-label="Technologies">{project.technologies.map((tech, i) => <li key={`${tech}-${i}`}>{tech}</li>)}</ul>{project.demo_available && project.live_url && <a href={project.live_url} target="_blank" rel="noreferrer">Historical demo ↗</a>}</div>
        </article>
      ))}</div>
    </main>
  );
}
